import React, { useEffect, useState } from "react";
import InsideHeader from "../../components/InsideHeader";
import svg23 from "../../assets/svg/svg23.svg";
import svg25 from "../../assets/svg/svg25.svg";
import svg26 from "../../assets/svg/svg26.svg";
import { useDispatch, useSelector } from "react-redux";
import { SearchOutlined } from "@ant-design/icons";
import { Input, Skeleton } from "antd";
import { addSpaces, cashConverter } from "../../utils";
import AccountAddModal from "./AccountAddModal";
import { fetchResellerAccounts } from "../../features/reseller-account/resellerAccountSlice";

function AccountsList() {
  const { resellerAccountData, loading } = useSelector(
    (state) => state.resellerAccount
  );
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const [prodd, setProdd] = useState();
  const [searchText, setSearchText] = useState("");

  const filteredData = searchText
    ? resellerAccountData?.filter((item) =>
        item?.accName?.toLowerCase().includes(searchText.toLowerCase())
      )
    : resellerAccountData;

  function fetchResellerAccountData() {
    dispatch(fetchResellerAccounts());
  }

  const handleAdd = async () => {
    await setProdd("");
    await showModal();
  };
  const handleEdit = async () => {
    showModal();
  };

  const handleRequest = async (item) => {
    // if (user?.layer === "ACCOUNT") {
    // } else {
    //   await dispatch(setResellerId(item));
    //   await navigate(-1);
    // }
  };

  useEffect(() => {
    fetchResellerAccountData();
  }, []);

  return (
    <>
      <div className="w-full h-full overflow-y-auto weiser-soft-scrollbar">
        <InsideHeader
          title="Accounts"
          subtitle="Create and manage account workspaces."
          back={false}
          compact={true}
        />

        <div className="lg:px-10 px-3 pt-4 pb-6">
          <div className="weiser-surface-toolbar">
            <div className="weiser-surface-toolbar-left">
              <span className="weiser-surface-link">Search accounts</span>
            </div>

            <div className="weiser-surface-toolbar-right w-full lg:w-auto">
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search account name"
                className="weiser-surface-search text-[16px] font-[400]"
                prefix={<SearchOutlined className="!text-[#6c7b8e]" />}
              />
            </div>
          </div>

          {user?.layer != "ACCOUNT" && (
            <div
              className="product-card !border-dashed mt-[1rem] mb-[1rem] min-h-[6.125rem] lg:w-[550px] w-full bg-[#f4f4f5] cursor-pointer"
              onClick={handleAdd}
            >
              <div className="flex items-center gap-x-5 p-[.875rem]">
                <div className="w-[3.875rem] h-[3.875rem] flex justify-center items-center bg-darkGreen rounded-full">
                  <img src={svg25} alt={"svg25"} />
                </div>

                <div className="reseller_card_title">New Account</div>
              </div>
            </div>
          )}

          {loading ? (
            <Skeleton />
          ) : (
            <div className="mt-[1rem] flex flex-shrink flex-wrap w-full gap-y-[1rem] gap-x-[1rem]">
              {filteredData?.length > 0 &&
                filteredData?.map((item) => (
                  <div
                    onClick={() => setProdd(item)}
                    className="cursor-pointer"
                  >
                    <div className="product-card  min-h-[7.125rem] lg:w-[550px] w-full">
                      <div className="flex justify-between p-[.875rem]">
                        <div
                          className="flex items-center gap-x-5"
                          onClick={() => handleRequest(item?.accId)}
                        >
                          <div className={`w-[3.875rem] h-[3.875rem] flex justify-center items-center ${item?.accMsgBal < 50 ? 'bg-red' :'bg-darkGreen' }  rounded-full`}>
                            <img src={svg23} alt={svg23} />
                          </div>

                          <div className="flex flex-col  ">
                            <div className="reseller_card_title">
                              {item?.accName}
                            </div>
                            <div className="reseller_card_sub_title">
                              +{addSpaces(item?.accAdminMobile)}
                            </div>
                            <div className="reseller_card_sub_title">
                              {cashConverter(item?.accSmsPrice)} - Sms Bal:{" "}
                              {cashConverter(item?.accMsgBal)}
                            </div>
                          </div>
                        </div>

                        <div className="flex justify-end" onClick={showModal}>
                          <img src={svg26} alt="svg26" />
                        </div>
                      </div>

                      <div className="bg-[#f4f4f5] p-[.875rem] flex flex-col">
                        <div className="reseller_card_title !text-[16px]">
                          Apps
                        </div>
                        <div className="reseller_card_sub_title">
                          This reseller has no apps
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
      <AccountAddModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        prodd={prodd}
      />
    </>
  );
}

export default AccountsList;
